import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { CookieHelper } from '../cookie-helper';
import { WindowRef } from '../helpers';

@Injectable({
  providedIn: 'root'
})
export class TrackJsUtils {
  public userId: string;

  constructor(
    private cookieHelper: CookieHelper,
    private service: AccountSummaryService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private winRef: WindowRef,
    private userSession: UserSessionService
  ) {}

  init() {
    const tealeafID = isPlatformBrowser(this.platformId)
      ? this.cookieHelper.getCookies('TLTSID')
      : null;
    if (this.userSession.getServiceWorkerCheck()) {
      this.getAccountSummary(tealeafID);
    }
  }

  getAccountSummary(tealeafID) {
    this.service.getAccountSummaryDetails().subscribe((data) => {
      if (data !== null) {
        if (
          data.loggedIn !== undefined &&
          data.loggedIn !== null &&
          data.loggedIn !== false
        ) {
          this.userId = data.smNumber;
        }
      } else {
        this.userId = 'notLoggedIn';
      }
      if (
        isPlatformBrowser(this.platformId) &&
        this.winRef.nativewindow !== undefined
      ) {
        this.winRef.nativewindow.window._trackJs.userId = this.userId;
        this.winRef.nativewindow.window._trackJs.sessionId = tealeafID;
      }
    });
  }
}
